import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { LubricationSelectionAssistantPageInitialData } from "./lubricationSelectionAssistantPageTypes";

export const lubricationSelectionAssistantPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.page("lubrication-selection-assistant"),
    queryFn: () =>
      fetchOccPageData<PageInitialDataResult<LubricationSelectionAssistantPageInitialData>>(
        "/page-data/lubrication-selection-assistant",
      ),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
